(function() { window.GUID_c7b95eb2_3dc1_41a4_a86a_194f3fdf28d2 = { getGuid: function() { return "c7b95eb2-3dc1-41a4-a86a-194f3fdf28d2"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var VideoPlayerInternals;
        (function (VideoPlayerInternals) {
            /** This class handle all about the video timeLine  */
            class VideoProgress extends VideoPlayerInternals.BaseInternal {
                constructor(player) {
                    super(player);
                    this.progressThumb_mouseDownInfo = {
                        movedX: 0,
                        mouseIsDown: false,
                        MouseDownPagePosition: null,
                        ThumbDownPosition: null,
                        VideoWasPlaying: false
                    };
                    this.progressThumb_seaked = (e) => {
                        this.video.removeEventListener("seeked", this.progressThumb_seaked);
                        //this.updateProgress();
                        if (this.progressThumb_mouseDownInfo.VideoWasPlaying)
                            this.player.PlayPause();
                    };
                    this.progressThumb_touchmove_cancel = () => { };
                    this.container = player.$Control;
                    this.video = player.video;
                    /*this.progressContainer = this.container.find('.progress-container');*/
                    var progress = this.elements.progressContainer.find('.progress');
                    if (progress.length > 0)
                        this.progressBar = progress[0];
                    var progressSlider = this.container.find('.progress-slider');
                    if (progressSlider.length > 0)
                        this.progressSlider = progressSlider[0];
                    if (this.elements.progressThumb.length > 0) {
                        this.progressThumb = this.elements.progressThumb[0];
                        this.progressThumb.style.left = "0px";
                    }
                    this.progressTooltips = new VideoPlayerInternals.ProgressTooltips(this);
                }
                OnBindEvents() {
                    this.event(this.video)
                        .offon("durationchange", () => { this.updateDuration(); });
                    if (this.progressThumb) {
                        var thumb = $(this.progressThumb);
                        this.event(thumb)
                            .offon("mousedown", (e) => { this.progressThumb_mouseDown(e); })
                            .offon("click", (e) => { e.stopPropagation(); e.preventDefault(); })
                            .add($("body")).add(this.elements.progressContainer)
                            .offon("mouseup", (e) => { this.progressThumb_mouseup(e); });
                        //thumb.offon("mousedown." + this.player.ControlId, (e, a) => { this.progressThumb_mouseDown(e); })
                        //    .offon("click." + this.player.ControlId, (e) => { e.stopPropagation(); e.preventDefault(); });
                        //thumb.add($("body")).add(this.progressContainer).offon("mouseup." + this.player.ControlId, (e, a) => { this.progressThumb_mouseup(e); });
                        //this.event(thumb)
                        //    .offon("touchstart", (e, a) => { this.progressThumb_touchstart(e); })
                        //    .offon("touchend", (e, a) => { this.progressThumb_touchend(e); })
                        //    .offon("touchcancel", (e, a) => { this.progressThumb_touchcancel(e); })
                        //    .add(this.progressContainer).offon("touchmove", (e, a) => { this.progressThumb_touchmove(e); });
                    }
                    this.event(this.elements.progressContainer)
                        .offon("click", (e, a) => {
                        var seconds = this.positionToSeconds(e.offsetX);
                        this.player.Seek(seconds);
                    });
                }
                OnDispose() {
                }
                updateProgress() {
                    var position = (this.video.currentTime / this.video.duration);
                    this.progressBar.style.width = position * 100 + "%";
                    if (this.progressSlider)
                        this.progressSlider.value = Math.round(position * 1000).toString();
                    if (this.progressThumb) {
                        this.progressThumb.style.left = this.progressBar.style.width;
                    }
                    this.elements.timeDisplay.cursor.text(this.displaySeconds(this.video.currentTime));
                }
                updateDuration() {
                    var totalSeconds = this.video.duration;
                    this.elements.timeDisplay.totalIsMoreThanOneHour = totalSeconds >= 60 * 60;
                    this.elements.timeDisplay.total.text(this.displaySeconds(totalSeconds));
                    this.elements.timeDisplay.cursor.text(this.displaySeconds(0));
                    this.eventRaiser.VideoLoaded(null, { videoPlayer: this.player.video });
                }
                positionToSeconds(x) {
                    var percent = x / this.elements.progressContainer.width();
                    return this.video.duration * percent;
                }
                ThumbMove_Begin(pageX, offsetX) {
                    var $progressThumb = $(this.progressThumb);
                    var info = this.progressThumb_mouseDownInfo;
                    info.VideoWasPlaying = this.player.IsPlaying;
                    if (info.VideoWasPlaying)
                        this.player.PlayPause();
                    info.mouseIsDown = true;
                    info.MouseDownPagePosition = pageX;
                    info.ThumbDownPosition = ($progressThumb.offset().left - this.elements.progressContainer.offset().left) + offsetX;
                    $progressThumb.removeClass("animate");
                }
                ThumbMove_Move(pageX) {
                    var info = this.progressThumb_mouseDownInfo;
                    if (info.mouseIsDown) {
                        var delta = pageX - info.MouseDownPagePosition;
                        info.movedX = info.ThumbDownPosition + delta;
                        this.progressThumb.style.left = info.movedX + "px";
                        return info.movedX;
                    }
                    return null;
                }
                ThumbMode_End() {
                    var info = this.progressThumb_mouseDownInfo;
                    if (info.mouseIsDown) {
                        $(this.progressThumb).addClass("animate");
                        info.mouseIsDown = false;
                        var seekSeconds = Math.floor(this.positionToSeconds(info.movedX));
                        this.video.addEventListener("seeked", this.progressThumb_seaked);
                        this.player.Seek(seekSeconds);
                        return true;
                    }
                    return false;
                }
                progressThumb_mouseDown(e) {
                    var info = this.progressThumb_mouseDownInfo;
                    this.ThumbMove_Begin(e.pageX, e.offsetX);
                    this.container.offon("mousemove." + this.player.ControlId, (e, a) => { this.progressThumb_mousemove(e); });
                    e.stopPropagation();
                    e.preventDefault();
                }
                progressThumb_mousemove(e) {
                    this.ThumbMove_Move(e.pageX);
                }
                progressThumb_mouseup(e) {
                    if (this.ThumbMode_End()) {
                        e.stopPropagation();
                        e.preventDefault();
                        this.container.off("mousemove." + this.player.ControlId);
                    }
                }
                progressThumb_touchstart(e) {
                    var te = e.originalEvent;
                    if (te.targetTouches && te.targetTouches.length > 0) {
                        var pageX = te.targetTouches[0].pageX;
                        var info = this.progressThumb_mouseDownInfo;
                        info.VideoWasPlaying = this.player.IsPlaying;
                        if (info.VideoWasPlaying)
                            this.player.PlayPause();
                        info.mouseIsDown = true;
                        info.MouseDownPagePosition = pageX;
                        var $thumb = $(this.progressThumb);
                        info.ThumbDownPosition = ($thumb.offset().left - this.elements.progressContainer.offset().left) + ($thumb.width() / 2); // + e.offsetX;
                        $thumb.removeClass("animate");
                        var resumeTouched = this.player.videoTouched.Suspend(true);
                        var removeTouchMove = this.event($(this.progressThumb))
                            .add(this.elements.progressContainer)
                            .offon("touchmove", (e, a) => { this.progressThumb_touchmove(e); })
                            .off;
                        this.progressThumb_touchmove_cancel = () => {
                            resumeTouched();
                            removeTouchMove();
                        };
                        this.progressTooltips.show();
                        this.progressTooltips.update(info.ThumbDownPosition);
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }
                progressThumb_touchend(e) {
                    var info = this.progressThumb_mouseDownInfo;
                    if (info.mouseIsDown) {
                        e.stopPropagation();
                        e.preventDefault();
                        this.progressTooltips.hide();
                        info.mouseIsDown = false;
                        this.container.off("mousemove." + this.player.ControlId);
                        var seekSeconds = Math.floor(this.positionToSeconds(info.movedX));
                        $(this.progressThumb).addClass("animate");
                        if (!isNaN(seekSeconds)) {
                            this.video.addEventListener("seeked", this.progressThumb_seaked);
                            this.progressThumb.style.transition = "all 0.2s";
                            this.player.Seek(seekSeconds);
                        }
                    }
                }
                progressThumb_touchcancel(e) { this.progressThumb_touchmove_cancel(); }
                progressThumb_touchmove(e) {
                    var info = this.progressThumb_mouseDownInfo;
                    if (info.mouseIsDown) {
                        var te = e.originalEvent;
                        if (te.targetTouches && te.targetTouches.length > 0) {
                            var pageX = te.targetTouches[0].pageX;
                            var delta = pageX - info.MouseDownPagePosition;
                            info.movedX = info.ThumbDownPosition + delta;
                            this.progressThumb.style.left = info.movedX + "px";
                            this.progressTooltips.update(info.movedX);
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }
                }
            }
            VideoPlayerInternals.VideoProgress = VideoProgress;
        })(VideoPlayerInternals = Controls.VideoPlayerInternals || (Controls.VideoPlayerInternals = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=VideoPlayer.VideoProgress.pre.js.map
